import { Card, FormField, Heading, InputWidth, ReadOnlyField } from '@msaf/core-react'
import { WellGeothermalTemperatureFields } from '../../../../types/form-types'

interface WellGeothermalTemperatureInterface {
  fields: Partial<WellGeothermalTemperatureFields>
  index: number
  isLoading: boolean
}

export default function WellGeothermalTemperatureView({
  fields,
  index,
  isLoading,
}: WellGeothermalTemperatureInterface) {
  return (
    <Card>
      <Heading isSkeleton={isLoading} level={4}>
        Reading {index + 1}
      </Heading>

      <FormField isSkeleton={isLoading} label='Date' labelId='date'>
        <ReadOnlyField
          fieldSize={InputWidth.large}
          isSkeleton={isLoading}
          labelledBy='date'
          value={`${fields['date'] ?? ''}`}
        />
      </FormField>

      <FormField isSkeleton={isLoading} label='Depth (m)' labelId='depth'>
        <ReadOnlyField
          fieldSize={InputWidth.large}
          isSkeleton={isLoading}
          labelledBy='depth'
          value={`${fields['depth'] ?? ''}`}
        />
      </FormField>

      <FormField isSkeleton={isLoading} label='Temperature (oC)' labelId='temperature'>
        <ReadOnlyField
          fieldSize={InputWidth.large}
          isSkeleton={isLoading}
          labelledBy='temperature'
          value={`${fields['temperature'] ?? ''}`}
        />
      </FormField>
    </Card>
  )
}
